import axios from "axios";
import { baseUrl } from "../Common/Constants";
import httpClient from "../Core/http";

class Api{
    getRunningPeriods(params:any): Promise<any> {
        let url = "runningPeriod/runningPeriods";
        
        const termsobj = {
        devicesWithSerial: params.devicesWithSerial,
        //alarmText:params.alarmText
        }

        if (params.devicesWithSerial == null){
            termsobj.devicesWithSerial = []
        }

        const terms = JSON.stringify(termsobj) 

        const queryObject = {
            bucketSize: params.bucketSize,
            start: params.start,
            end: params.end,
            terms: terms,
        }
        //only fetch if terms have any value other than null or empty
        if (!Object.values(termsobj).every(value => value == null || value.length == 0)) {
            return httpClient.get(url, { params: queryObject }).then((response) => {
                    return response.data;
                })
                    .catch((error) => {
                        return error;
                        console.log(error);
                    });
         
        }
    }
    
    getRunningPeriodCount(params:any): Promise<any> {
        let url = "runningPeriod/runningPeriodCount";

        const termsobj = {
            country: params.country,
            customerID: params.customerID,
            deviceTypes: params.deviceTypes,
            devicesWithSerial: params.devicesWithSerial,
          }

          if (params.devicesWithSerial == null){
            termsobj.devicesWithSerial = []
          }
          if (params.deviceTypes == null){
            termsobj.deviceTypes = []
          }
        const terms = JSON.stringify(termsobj) 

        const queryObject = {
            bucketSize: params.bucketSize,
            start: params.start,
            end: params.end,
            terms: terms,
            scope: params.scope 
        }
        //only fetch if terms have any value other than null or empty
            return  httpClient.get(url, { params: queryObject }).then((response) => {
                return response.data;
            })
                    .catch((error) => {
                        return error;
                        console.log(error);
                    });
           
        
    }   
}

export const RunningPeriodsApi = new Api();